// NOTE: AUTO GENERATED FILE! Do not modify directly!

export enum ButtonColorsEnum {
  'primary' = 'primary',
  'secondary' = 'secondary',
  'facebook' = 'facebook',
  'instagram' = 'instagram',
  'alert' = 'alert',
  'white' = 'white',
  'grey' = 'grey'
}
